<template>
  <div>
    <ticket-list :tickets="tickets" @onRowClick="onRowClick"></ticket-list>
    <pagination
      style="text-align:center;"
      v-model="list.pageIndex"
      :total-page="list.totalPage"
      @change="onPageChange"
    />
  </div>
</template>

<script>
import TicketList from '../components/list/Tickets'
import * as T from '../store/types'

export default {
  components: {
    TicketList
  },
  computed: {
    tickets() {
      return this.$store.state.tickets.list.items
    },
    list() {
      return this.$store.state.tickets.list
    }
  },
  mounted() {
    this.$store
      .dispatch(T.DO_GET_TICKET_LIST)
      .then(res => {})
      .catch(res => {})
  },
  methods: {
    onRowClick(item) {
      this.$router.push(`/ticket/${item.idView}`)
    },
    onPageChange() {
      this.$store
        .dispatch(T.DO_GET_TICKET_LIST)
        .then(res => {})
        .catch(res => {})
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/RecentTickets.vue